<template>
  <div class="container">
    <div class="left">
      <div class="price">
        <div>销量：</div>
        <div class="money">
          {{ userInfo.pay_count }}
          <!-- {{ userInfo.brokerage_price.split(".")[0]
          }}<span class="pointe"
            >.{{ userInfo.brokerage_price.split(".")[1] }}</span
          > -->
        </div>
      </div>
      <div class="money-icon">
        <img src="@assets/pc/images/home/money-icon.png" alt="" />
      </div>
    </div>
    <div class="right">
      <div class="item-left item">
        <div class="up" @click="goChange(0)">
          <div>推广名片</div>
        </div>
        <!-- <div class="down" @click="goChange(2)">
          <div>佣金明细</div>
        </div> -->
      </div>
      <div class="item-right item">
        <div class="up" @click="goChange(1)">
          <div>推广人统计</div>
        </div>
        <div class="down" @click="goChange(3)">
          <div>推广人订单</div>
        </div>
      </div>
    </div>
    <MaskModel :maskShow="maskShow" :width="600" @on-cancel="cancel">
      <div class="title">佣金明细</div>
      <div class="content">
        <div class="money1">佣金明细￥{{ commissionCount }}</div>
        <div class="list">
          <div class="item" v-for="item of spreadInfoList" :key="item.time">
            <div class="time">{{ item.time }}</div>
            <div class="detail" v-for="val of item.list" :key="val.add_time">
              <div class="left1">
                <div class="tip">{{ val.title }}</div>
              </div>
              <div class="time1">{{ val.add_time }}</div>
              <div class="right1" v-if="val.pm === 1">+{{ val.number }}</div>
              <div class="right1 red" v-else>-{{ val.number }}</div>
            </div>
          </div>
        </div>
      </div>
    </MaskModel>
  </div>
</template>

<script>
import MaskModel from "@/components/pc/MaskModel";
import { getSpreadInfo, getCommissionInfo } from "@api/user";
import { mapState } from "vuex";
export default {
  name: "MyPromotion",
  components: {
    MaskModel
  },
  data() {
    return {
      maskShow: false,
      spreadInfoList: [],
      commissionCount: "",
      param: {
        page: 1,
        limit: 3
      }
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  created() {
    console.log(this.userInfo);
  },
  methods: {
    goChange(index) {
      if (index === 0) {
        this.$router.push({
          path: "/home/businessCard"
        });
      } else if (index === 1) {
        this.$router.push({
          path: "/home/businessTotal"
        });
      } else if (index === 2) {
        this.maskShow = true;
        this.getSpreadInfoList();
        this.getCommissionInfoList();
      } else {
        this.$router.push({
          path: "/home/businessOrder"
        });
      }
    },
    cancel() {
      this.maskShow = false;
    },
    getSpreadInfoList() {
      getSpreadInfo().then(res => {
        this.commissionCount = res.data.commissionCount;
      });
    },
    getCommissionInfoList() {
      getCommissionInfo(this.param, 3).then(res => {
        this.spreadInfoList = res.data;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  display flex
  height 500px
  .left
    display flex
    margin-top 140px
    margin-left 100px
    .price
      font-size 16px
      .money
        font-size 36px
        font-weight 700
        color #ff3f39
        margin-top 10px
        .pointe
          font-size 20px
    .money-icon
      width 60px
      height 60px
      margin-left 50px
      margin-top 20px
      img
        width 100%
        height 100%
  .right
    display flex
    justify-content space-between
    margin-top 50px
    margin-left 150px
    .item
      width 250px
      height 250px
      display flex
      flex-direction column
      justify-content space-between
      >div
        border-radius 4px
        font-size 18px
        div
          margin-left 30px
          transform translateY(30px)
    .item-left
      margin-right 20px
      .up
        cursor pointer
        height 110px
        background url(../../../assets/pc/images/home/box-1.png) no-repeat 100% 100%
        margin-bottom 20px
        color #ffab18
      .down
        cursor pointer
        height 150px
        background url(../../../assets/pc/images/home/box-2.png) no-repeat 100% 100%
        color #1abbfe
        div
          transform translateY(34px)
    .item-right
      .up
        cursor pointer
        height 150px
        background url(../../../assets/pc/images/home/box-3.png) no-repeat 100% 100%
        margin-bottom 20px
        color #188fff
        div
          transform translateY(34px)
      .down
        cursor pointer
        height 110px
        background url(../../../assets/pc/images/home/box-4.png) no-repeat 100% 100%
        color #ff453a
.title
  line-height 40px
  font-size 16px
  color-adjust #333
  padding-bottom 10px
  border-bottom 1px solid #ccc
.content
  min-height 300px
  .money1
    line-height 28px
    margin-bottom 10px
  .list
    .time
      background #e9e9e9
      line-height 24px
      text-align left
      padding 0 10px
    .detail
      line-height 40px
      padding 0 40px
      display flex
      justify-content space-between
      border-bottom 1px dashed #ccc
      .tip
        font-size 14px
      .time1
        color #a9a9a9
      .right1
        color #16ac57
        font-size 14px
        &.red
          color #fc4d3d
</style>
